export default __webpack_public_path__ + "maps-examples-fill-pattern-thumbnail-480-c5dd98f62c3eecb75260660a9a47a7f1.webp";